import { Component, OnInit, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { GtmService } from '@xbh/common-lib';
import { filter } from 'rxjs/operators';
import { CopyrightComponent } from './shared/copyright/copyright.component';
import { PageFooterComponent } from './shared/page-footer/page-footer.component';
import { PageHeaderComponent } from './shared/page-header/page-header.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, PageHeaderComponent, PageFooterComponent, CopyrightComponent],
  templateUrl: './app.html',
  styleUrls: ['./app.scss'],
})
export class App implements OnInit {
  protected readonly title = signal('sap');
  protected readonly showCopyright = signal(true);
  private readonly router = inject(Router);
  private readonly gtmService = inject(GtmService);

  ngOnInit() {
    const GTM_ID = 'GTM-K2WC2FV';
    // GTMコンテナIDを指定
    this.gtmService.init(GTM_ID);
    this.updateLayout(this.router.url);

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
      this.updateLayout(event.urlAfterRedirects);

      this.gtmService.pushEvent({
        event: 'page_view',
        url: event.urlAfterRedirects,
      });
    });
  }

  /**
   * ルート変更時にレイアウトを更新する
   * @param url 現在のURL
   */
  private updateLayout(url: string) {
    this.showCopyright.set(!url.includes('sap-app/error'));
  }
}
